import SVG from 'react-inlinesvg';
import { useRecoilValue } from 'recoil';
import { themeModeAtom, themeModeEnum } from '../recoil/atoms/themeModeAtom';
import { toAbsoluteUrl } from '../_metronic/_helpers';

export function UserSettingsIcon() {
  const themeMode = useRecoilValue(themeModeAtom);
  return themeMode === themeModeEnum.DARK_MODE ? (
    <SVG
      style={{
        width: 16,
        height: 16,
        marginTop: '5px',
        marginLeft: '3px',
        marginRight: '15px',
      }}
      src={toAbsoluteUrl(
        '/media/svg/icons/General/user-settings-icon-light.svg'
      )}
    />
  ) : (
    <SVG
      style={{
        width: 16,
        height: 16,
        marginTop: '5px',
        marginLeft: '3px',
        marginRight: '15px',
      }}
      src={toAbsoluteUrl('/media/svg/icons/General/user-settings-icon.svg')}
    />
  );
}
export function AdvancedIcon() {
  const themeMode = useRecoilValue(themeModeAtom);
  return themeMode === themeModeEnum.DARK_MODE ? (
    <SVG
      style={{
        width: 16,
        height: 16,
        marginTop: '3px',
        marginLeft: '3px',
        marginRight: '15px',
      }}
      src={toAbsoluteUrl('/media/svg/icons/General/advanced-icon-light.svg')}
    />
  ) : (
    <SVG
      style={{
        width: 16,
        height: 16,
        marginTop: '3px',
        marginLeft: '3px',
        marginRight: '15px',
      }}
      src={toAbsoluteUrl('/media/svg/icons/General/advanced-icon.svg')}
    />
  );
}
export function CrmIcon() {
  const themeMode = useRecoilValue(themeModeAtom);
  return themeMode === themeModeEnum.DARK_MODE ? (
    <SVG
      style={{
        width: 18,
        height: 18,
        marginTop: '3px',
        marginRight: '15px',
      }}
      src={toAbsoluteUrl('/media/svg/icons/General/crm-icon-light.svg')}
    />
  ) : (
    <SVG
      style={{
        width: 18,
        height: 18,
        marginTop: '3px',
        marginRight: '15px',
      }}
      src={toAbsoluteUrl('/media/svg/icons/General/crm-icon.svg')}
    />
  );
}
